import {Grid} from '@material-ui/core';
import {autobind} from 'core-decorators';

import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Add} from '@material-ui/icons';
import {Form, Toggle} from 'components/forms';
import Text from 'components/text';

import Button from 'components/button';
import {reverse, urlPatterns} from 'core/urls';
import AddressCard from 'components/address-grid/address-card';
import styles from './styles.css';

@autobind
export default class AddressGridForm extends Component {
    static propTypes = {
        addresses: PropTypes.array.isRequired,
        disableCreation: PropTypes.bool,
        onDelete: PropTypes.func,
        onSubmit: PropTypes.func,
        returnUrl: PropTypes.string,
        returnData: PropTypes.object,
    };

    static contextTypes = {
        router: PropTypes.object,
    };

    state = {};

    async handleSubmit(values) {
        this.setState({loading: true, errors: undefined});

        const count = Object.keys(values).filter(value => values[value]);
        if (count.length >= 2) {
            this.setState({errors: {formError: 'No puede seleccionar mas de uno.'}});
            return;
        }
        const addressesObject = {addresses: [values]};
        const updatedAddresses = {
            addresses: addressesObject.addresses[0] ?
                Object.entries(addressesObject.addresses[0]).reduce((acc, [id, isDefault]) => {
                    acc.push({id: parseInt(id), isDefault});
                    return acc;
                }, [])
                : [],
        };

        const response = await this.props.onSubmit(updatedAddresses);
        this.setState({loading: false});
        if (this.props.dataKey && response.data[this.props.dataKey].errors) {
            this.setState({
                loading: false,
                errors: response.data[this.props.dataKey].errors,
            });
        } else if (this.props.returnUrl) {
            this.setState({loading: false});
            this.context.router.history.push({
                pathname: this.props.returnUrl,
                state: {
                    returnData: {
                        ...(this.props.returnData || {}),
                        address: Object.keys(values).find(value => values[value]),
                    },
                },
            });
        } else {
            this.context.router.history.push(reverse('addressBook'));
        }
    }

    render() {
        const {returnUrl, returnData} = this.props;
        const returnName = returnUrl ? urlPatterns.find(route => route.path === returnUrl).name : null;
        return (
            <Form
                fields={this.props.addresses.map(address => ({
                    key: address.id,
                    initial: address.isDefault,
                }))}
                onSubmit={this.handleSubmit}
                errors={this.state.errors}>
                {({getFieldProps, renderErrors, values}) => {
                    return (
                        <Grid container spacing={4} className={styles.root}>
                            <Grid container={true} justify='space-between'>
                                <Grid item xs={4} className={styles.buttonContainer}>
                                    <Link to={{
                                        pathname: reverse(returnName || 'home'),
                                        state: {returnUrl, returnData},
                                    }}>
                                        <Button
                                            className={styles.addAddress}
                                            theme='white'
                                            type='button'
                                            onClick={this.handleAddress}>
                                            <Text
                                                variant='h2'
                                                className={styles.buttonText}
                                                bold='bold'>
                                                Volver
                                            </Text>
                                        </Button>
                                    </Link>
                                </Grid>
                                <Grid container item xs={8}>
                                    <Grid item xs={8} className={styles.buttonContainer} style={{textAlign: 'right'}}>
                                        <Button
                                            className={styles.addAddress}
                                            theme='yellow'
                                            type='submit'
                                            fullwidth
                                            disabled={this.state.loading}
                                            onClick={this.handleAddress}>
                                            <Text
                                                variant='h2'
                                                className={styles.buttonText}
                                                bold='bold'>
                                                {this.state.loading ? 'Guardando...' : 'Establecer como predeterminada'}
                                            </Text>
                                        </Button>
                                        {renderErrors('formError')}
                                    </Grid>
                                    {!this.props.disableCreation && (
                                        <Grid item xs={4} className={styles.buttonContainer}>
                                            <Link to={{
                                                pathname: reverse('createAddress'),
                                                state: {
                                                    returnUrl: this.props.returnUrl,
                                                    returnData: this.props.returnData,
                                                },
                                            }}>
                                                <Button
                                                    className={styles.addAddress}
                                                    theme='yellow'
                                                    type='button'
                                                    onClick={this.handleAddress}>
                                                    <Text
                                                        variant='h2'
                                                        className={styles.buttonText}
                                                        bold='bold'>
                                                        <Add fontSize='large'/>
                                                        Agregar dirección
                                                    </Text>
                                                </Button>
                                            </Link>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                            {this.props.addresses.map(address => ((
                                <Grid item xs={12}>
                                    <Grid container spacing={0} alignItems='center'>
                                        <Grid item xs={1}>
                                            <Toggle
                                                type='checkbox'
                                                value={values.isDefault}
                                                {...getFieldProps(address.id)}
                                                 onChange={value => {
                                                    Object.keys(values).forEach(key => values[key] = false);
                                                    getFieldProps(address.id).onChange(value);
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <AddressCard
                                                key={address.id}
                                                address={address}
                                                onDelete={this.props.onDelete}
                                                onBlur={this.props.onBlur}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )))}
                        </Grid>
                    );
                }}
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./views/addresses/address-grid-form/index.js